export default __webpack_public_path__ + "static/media/feather-upload.bf992bb6.svg";